import React from "react";
import { useTranslation } from "../../../../localization/useTranslation";
import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";

import { Box } from "@mui/material";

export interface ICompleteValidationDialog {
    open: boolean;
    OnCompleteClick: () => void;
    onDialogClose: () => void;
    InProgress: boolean;
}

export default function CompleteValidationDialog(props: ICompleteValidationDialog) {
    const { translateString } = useTranslation();

    return (
        <DotLegalDialog
            header={translateString("validating")}
            buttonOkText={translateString("validate")}
            open={props.open ?? false}
            size="md"
            inProgress={props.InProgress}
            secondaryButtonText={translateString("cancel")}
            onDialogClose={props.onDialogClose}
            onSecondaryButtonClick={props.onDialogClose}
            onOkClick={props.OnCompleteClick}
        >
            <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <DotLegalHeader center headerStyle={"small"} marginBottom={0} fontWeight={400}>
                    {translateString("completeDialogContent")}
                </DotLegalHeader>
            </Box>
        </DotLegalDialog>
    );
}
